import PricingModelTable from "../Tables/PricingModelTable";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { Constants, TabEnum, ButtonType } from "../Content";
import SearchBoxSection from "../SearchBox/SearchBoxSection";
import { toVariableNameFormat } from "../../../Helper/Helper";
import Loader from "../../utilities/Loader/Loader";
import Notification from "../../utilities/Notification/Notification";
import { Congiguration } from "../../../Constants/AppConstants";
import { Severity } from "../../utilities/Notification/NotificationContent";
import { isJsonString } from "../../../Helper/Helper";
import { LocalStorageKeys } from "../../QuoteRequest/Content";
import {
    getProductPricingModelMasterData, saveProductPricingModelMasterData
} from "../../../Actions/ManageDataAction";
const PricingModels = ({
    handleDownloadData,
    Tab,
    headers,
    rows,
    reload
}) => {
    const [pricingStructures, setPricingStructures] = useState([]);
    const [updatedModel, setUpdatedModel] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [headerData, setHeaderData] = useState(headers);
    const dispatch = useDispatch();
    const [loadingState, setLoadingState] = useState(false);
    const [notificationMsg, setNotificationMsg] = useState("");
    const [notificationSeverity, setNotificationSeverity] = useState("");
    const [showNotification, setShowNotification] = useState(false);
    const loggedUser = isJsonString(
        sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)
    )
        ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
        : null;
    useEffect(() => {
        switch (Tab) {
            case TabEnum.PRODUCTPRICINGMODELS:
                GetProductPricingModelMasterData();
                break;
            default:
                setRowData(rows);
                break;
        }
    }, [reload]);
    //#region
    const closeNotificationPopup = () => {
        setShowNotification(false);
    };
    function GetProductPricingModelMasterData() {
        setLoadingState(true);
        try {
            dispatch(getProductPricingModelMasterData())
                .then((data) => {
                    let products = data?.products;
                    let pricingStructure = data?.pricingStructures;
                    let productPricing = data?.productPricingModel;

                    setPricingStructures(pricingStructure);

                    const newColumns = pricingStructure.map((item) => ({
                        id: toVariableNameFormat(item.pricingStructureName),
                        header: item.pricingStructureName,
                    }));                    
                    //take 0th element from prevArray i.e. productId, productName which displays the first column
                    setHeaderData((prevArray) => [prevArray[0], ...newColumns]);
                    //setHeaderData([...newColumns]);
                    const tableRows = products.concat(productPricing);
                    if (tableRows?.length != null) {
                        const result = tableRows.reduce((acc, obj) => {

                            const { productName, pricingStructureName, id } = obj;

                            const existingRow = acc.find(
                                (row) => row.productName === productName
                            );

                            if (!existingRow) {
                                const newRow = { productName, id };
                                newRow[toVariableNameFormat(pricingStructureName)] = true;
                                acc.push(newRow);
                            } else {
                                existingRow[toVariableNameFormat(pricingStructureName)] = true;
                            }
                            return acc;
                        }, []);

                        result.map((x) => {
                            newColumns.map((y) => {
                                x[y.id] = x[y.id] === undefined ? false : x[y.id];
                            });
                        });

                        setRowData(result);
                    }
                    setLoadingState(false);
                })
                .catch((e) => {
                    console.log(e);
                    setLoadingState(false);
                });
        } catch (e) {
            console.log(e);
            setLoadingState(false);
        }
    }

    const handleInputChanges = (event, header, newrow) => {
        let pricingStructureId = pricingStructures.find(x => x.pricingStructureName === header.header)?.id;
        const currentModel = [...updatedModel];
        let existingIndex = currentModel?.findIndex(x => x?.productId === newrow.id && x.pricingStructureId === pricingStructureId);
        if (existingIndex > -1) {
            currentModel.splice(existingIndex, 1);
        }
        else {
            currentModel.push({ productId: newrow.id, pricingStructureId: pricingStructureId });
        }
        newrow[header.id] = event.target.checked;
        setUpdatedModel(currentModel);
        setRowData((oldRows) => {
            const existingRowIndex = oldRows?.findIndex(
                (row) =>
                    row.id === newrow.id
            );
            if (existingRowIndex !== -1) {
                return oldRows.map((row, index) => {
                    if (index === existingRowIndex) {
                        return newrow;
                    }
                    return row;
                });
            } else {
                return [...oldRows, newrow];
            }
        });
    };
    const handleSave = (event) => {
        setLoadingState(true);
        if (updatedModel.length === 0) {
            setNotificationMsg(Constants.NOCHANGE);
            setNotificationSeverity(Severity.INFO);
            setShowNotification(true);
            setLoadingState(false);
            return false;
        }
        else {
            const productPricing =
            {
                companyId: Congiguration.CompanyId,
                isBulkUpload: false,
                userId: loggedUser?.user?.id,
                listProductPricingModel: updatedModel
            };
            try {
                dispatch(saveProductPricingModelMasterData(productPricing))
                    .then((data) => {
                        if (data != null && data?.result === 1) {
                            GetProductPricingModelMasterData();
                            setNotificationMsg(Constants.SAVESUCCESSFUL);
                            setNotificationSeverity(Severity.SUCCESS);
                            setShowNotification(true);
                            setUpdatedModel([]);
                            setLoadingState(false);
                        }
                        else {
                            GetProductPricingModelMasterData();
                            setLoadingState(false);
                            setUpdatedModel([]);
                            setNotificationMsg(Constants.SAVEFAILED);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        GetProductPricingModelMasterData();
                        setLoadingState(false);

                    });
            } catch (e) {

                console.log(e);
                setLoadingState(false);
            }
        }
    }
    //#endregion
    return (
        <>
            <Box className="boxWrapper">
                <Box className="tabWrapper">
                    <Box className="tableWrapper">
                        <div className="singlebuttonTab">
                            <SearchBoxSection
                                isPricingTab={true}
                                handleDownloadData={handleDownloadData}
                                handleProductUpdate={handleSave}
                                data={rowData}
                                headers={headerData}
                            />
                        </div>
                        <PricingModelTable
                            headers={headerData}
                            rows={rowData}
                            handleCheckboxChange={handleInputChanges}
                        />
                    </Box>
                </Box>
            </Box>
            {showNotification && (
                <Notification
                    open={showNotification}
                    onClose={closeNotificationPopup}
                    message={notificationMsg}
                    severity={notificationSeverity}
                />
            )}
            {loadingState && <Loader open={loadingState} />}
        </>
    );
};

export default PricingModels;
